import React from 'react';
import Select from '../../../core/form/Select';
import Card from '../../../core/layout/Card';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import Separator from '../../../core/layout/Separator';
import FormButtons from '../../../core/form/FormButtons';
import PropTypes from 'prop-types';
import Button from '../../../core/form/Button';
import ReactivateContractProductsListContainer from './ReactivateContractProductsListContainer';
import MonthInput from '../../../core/form/MonthInput';

function ReactivateContractForm({ values, errors, onSubmit, onChange, submitting, loading, onAddProduct, onReset }) {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <Card title="Reactivate Info">
        <Row>
          <Column size={3}>
            <Select
              required
              label="Type"
              options={[
                { label: 'Post Payment', value: 'POST_PAYMENT' },
                { label: 'Up Front', value: 'UPFRONT' },
              ]}
              value={values.type}
              onChange={(value) => onChange('type', value)}
              errorText={errors.type}
            />
          </Column>
          <Column size={3}>
            <MonthInput
              label="Starts at"
              required={values.type === 'POST_PAYMENT'}
              disabled={values.type === 'UPFRONT'}
              value={values.startsAt}
              onChange={(value) => onChange('startsAt', value)}
              errorText={errors.startsAt}
            />
          </Column>
          <Column size={3}>
            <MonthInput
              label="Ends at"
              disabled={values.type === 'UPFRONT'}
              value={values.endsAt}
              onChange={(value) => onChange('endsAt', value)}
              errorText={errors.endsAt}
            />
          </Column>
          <Column size={3}>
            <Select
              required={values.type === 'POST_PAYMENT'}
              disabled={values.type === 'UPFRONT'}
              label="Due day"
              options={[...Array(31).keys()].map((n) => ({
                label: n + 1,
                value: n + 1,
              }))}
              value={values.dueDay}
              onChange={(value) => onChange('dueDay', value)}
              errorText={errors.dueDay}
            />
          </Column>
        </Row>
      </Card>
      <Separator />
      <Card
        title="Reactivate Products"
        actions={<Button label="Add Product" onClick={onAddProduct} disabled={submitting || loading} />}
      >
        <ReactivateContractProductsListContainer />
      </Card>
      <Separator />
      <FormButtons
        confirmLabel="Reactivate Contract"
        isDisabled={submitting || loading}
        isSubmitting={submitting}
        onReset={onReset}
      />
    </form>
  );
}

ReactivateContractForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.object,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  loading: PropTypes.bool,
  onAddProduct: PropTypes.func.isRequired,
};
ReactivateContractForm.defaultProps = {
  values: {},
  errors: {},
};

export default ReactivateContractForm;
